export default "/images/56342960e9344abbf2e4f6a7d78cde41.png";